<template>
  <div class="course-selector">
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="course-selector-popover"
      :visible-arrow="false"
      v-model="popoverVisible"
      v-if="isBatchBook && courses.length > 1"
    >
      <div class="book-course-list">
        <div
          v-for="(item, index) in courses"
          :key="item.course_id"
          class="book-course-item"
          :class="{
            active: selectedCourse.course_id === item.course_id,
            noMargin: index === courses.length - 1,
          }"
          @click="selectCourse(item)"
        >
          <span class="book-course-tag">
            {{ showSubjectTag[item.subject] }}
          </span>
          <span class="book-course-item-title">
            {{ item.title }}
          </span>
        </div>
      </div>
      <div slot="reference" class="book-course-trigger">
        <div class="book-course-trigger-content">
          <div class="book-course-trigger-content-left">
            <div class="left-content">
              <span class="book-course-tag">{{ showSubjectTag[selectedCourse.subject] }}</span>
              <div class="book-course-trigger-content-left-title">
                {{ selectedCourse.title }}
              </div>
            </div>
            <div class="left-content-sub">共{{ selectedCourse.section_num }}课节</div>
          </div>
          <div class="book-course-trigger-content-right">
            <div class="arrow-icon" :class="{ 'arrow-up': popoverVisible }">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.25 4.67003C12.25 4.81936 12.1929 4.96928 12.0791 5.08303L7.40836 9.7462C7.18086 9.9737 6.81161 9.9737 6.58411 9.74561L1.92094 5.08245C1.69286 4.85436 1.69286 4.4857 1.92094 4.25761C2.14902 4.02953 2.51769 4.02953 2.74577 4.25761L6.99652 8.50836L11.2543 4.25703C11.4824 4.02953 11.8516 4.02953 12.0797 4.25761C12.1929 4.37136 12.25 4.5207 12.25 4.67003Z"
                  fill="#A6A6B1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <div slot="reference" class="book-course-trigger no-popover" v-else>
      <div class="book-course-trigger-content">
        <div class="book-course-trigger-content-left">
          <div class="left-content">
            <span class="book-course-tag">{{ showSubjectTag[selectedCourse.subject] }}</span>
            <div class="book-course-trigger-content-left-title">
              {{ selectedCourse.title }}
            </div>
          </div>
          <div class="left-content-sub">共{{ selectedCourse.section_num }}课节</div>
        </div>
        <!-- <div class="book-course-trigger-content-right">
          <div class="arrow-icon" :class="{ 'arrow-up': popoverVisible }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.25 4.67003C12.25 4.81936 12.1929 4.96928 12.0791 5.08303L7.40836 9.7462C7.18086 9.9737 6.81161 9.9737 6.58411 9.74561L1.92094 5.08245C1.69286 4.85436 1.69286 4.4857 1.92094 4.25761C2.14902 4.02953 2.51769 4.02953 2.74577 4.25761L6.99652 8.50836L11.2543 4.25703C11.4824 4.02953 11.8516 4.02953 12.0797 4.25761C12.1929 4.37136 12.25 4.5207 12.25 4.67003Z"
                fill="#A6A6B1"
              />
            </svg>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
const GZ_SUBJECT = {
  1: '语文',
  2: '数学',
  3: '英语',
  4: '物理',
  5: '素质课',
  6: '化学',
  99: '综合课',
};
const CZ_SUBJECT = {
  1: '人文',
  2: '思维',
  3: '演说',
  4: '科学',
  5: '素质课',
  6: '实验',
  99: '综合课',
};
export default {
  name: 'SubjectSelector',
  props: {
    // 可以通过 props 传入初始选中的学科
    courses: {
      type: Array,
      default: () => [],
    },
    selectedCourse: {
      type: Object,
      default: () => {},
    },
    isBatchBook: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popoverVisible: false,
      showSubjectTag: location.hostname.includes('czmstt') ? CZ_SUBJECT : GZ_SUBJECT,
    };
  },
  async mounted() {},
  methods: {
    selectCourse(course) {
      this.popoverVisible = false;
      // 向父组件发送选中的学科
      this.$emit('onChange', course);
    },
    // 添加新方法，用于滚动到选中的元素
    scrollToActiveItem() {
      this.$nextTick(() => {
        const container = document.querySelector('.book-course-list');
        const activeItem = container?.querySelector('.book-course-item.active');

        if (container && activeItem) {
          // 检查元素是否在可视区域内
          const containerRect = container.getBoundingClientRect();
          const activeItemRect = activeItem.getBoundingClientRect();

          // 元素顶部在容器顶部以上，或元素底部在容器底部以下时需要滚动
          if (
            activeItemRect.top < containerRect.top ||
            activeItemRect.bottom > containerRect.bottom
          ) {
            if (activeItem.scrollIntoView) {
              // 滚动到元素位置，使其在容器中可见
              activeItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            } else {
              const offsetTop = activeItem.offsetTop - container.offsetTop;

              // 使用scrollTop属性进行滚动（更兼容的方式）
              // 将元素滚动到容器中间位置
              const scrollPosition =
                offsetTop - container.clientHeight / 2 + activeItem.clientHeight / 2;

              // 平滑滚动的兼容实现
              this.smoothScroll(container, container.scrollTop, scrollPosition, 300);
            }
          }
        }
      });
    },
    smoothScroll(element, start, end, duration) {
      // 如果浏览器支持原生的平滑滚动，直接使用
      if ('scrollBehavior' in document.documentElement.style) {
        element.scrollTop = end;
        return;
      }

      // 否则使用JS实现平滑滚动
      const startTime = performance.now();

      function scroll(timestamp) {
        const currentTime = timestamp - startTime;
        const progress = Math.min(currentTime / duration, 1);

        // 使用缓动函数使滚动更自然
        const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
        const value = start + (end - start) * easeInOutQuad(progress);

        element.scrollTop = value;

        if (currentTime < duration) {
          window.requestAnimationFrame(scroll);
        }
      }

      window.requestAnimationFrame(scroll);
    },
  },
  watch: {
    // 监听popover的显示状态
    popoverVisible(newVal) {
      if (newVal) {
        // 当popover显示时，滚动到选中的元素
        this.scrollToActiveItem();
      }
    },
    // 监听选中的学科变化
    selectedSubject() {
      // 当选中的学科变化时，如果popover是显示的，滚动到选中的元素
      if (this.popoverVisible) {
        this.scrollToActiveItem();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subject-selector {
  display: inline-block;
  position: relative;
}

.book-course-tag {
  font-size: 12px;
  background-color: #ffebeb;
  color: #ff4242;
  line-height: 16px;
  padding: 4px 8px;
  border-radius: 4px;
}
.book-course-trigger.no-popover {
  cursor: default;
}
.book-course-trigger {
  cursor: pointer;

  .book-course-trigger-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f7f8fa;
    padding: 8px 16px;
    border-radius: 8px;
    &-left {
      flex: 1;
      overflow: hidden;
      .left-content {
        display: flex;
        align-items: center;
        &-sub {
          margin-top: 8px;
          font-size: 14px;
          color: #1e1c22;
          line-height: 20px;
          font-weight: 400;
        }
      }
      &-title {
        flex: 1;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #1e1c22;
        margin-left: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .arrow-icon {
      display: flex;
      transition: transform 0.3s ease;

      svg {
        width: 14px;
        height: 14px;
      }
      &.arrow-up {
        transform: rotate(180deg);
      }
    }
  }

  .sel-arrow {
    font-size: 11px;
    color: #1d1b20;
    transition: transform 0.3s;
  }

  .subject-label-active {
    color: #ff2020;
    & + .sel-arrow {
      color: #ff2020;
    }
  }
}

.book-course-list {
  width: 432px;
  box-sizing: border-box;
  max-height: 192px;
  overflow-y: auto;
  padding: 8px;

  .book-course-item {
    display: flex;
    align-items: center;
    padding: 9px 8px;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    color: #000;
    transition: all 0.3s;

    &-title {
      margin-left: 8px;
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #1e1c22;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &:hover {
      background-color: #fafafa;
    }

    &.active {
      background-color: #ffefef;
      color: #ff2020;
      font-weight: 500;
      .book-course-tag {
        background-color: #fcc;
        color: #ff4242;
      }
      .book-course-item-title {
        color: #ff2020;
      }
    }

    &.noMargin {
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
/* 全局样式，确保弹出框样式正确 */
.el-popover.course-selector-popover {
  padding: 0;
  min-width: 100px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 4px;
}
</style>
